import React, { useEffect, useState } from "react";
import { Input, UncontrolledTooltip } from "reactstrap";
import { Notification, FullViewContainer, ActionIcon } from "../common/style";
import { SummaryButton } from "./style";
import ProjectDropDown from "./ProjectDropDown";
import OrderReview from "./OrderReview";
import CrudModal from "./CrudModal";
import { useContext } from "react";
import { AppContext } from "../context";
import ModuleListAccordion from "./ModuleListAccordion";
import {
  addUserRoom,
  addUserGroup,
  deleteUserRoom,
  updateUserProject,
  updateUserGroup,
  updateUserRoom,
} from "./service";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ExpoImg } from "../assets/img/expo_icon.svg";
import { ReactComponent as MaterialIcon } from "../assets/img/material.svg";

const ProjectSummary = ({
  isLoading,
  setIsLoading,
  currentRoom,
  projectSummary,
  selectionManager,
  setCurrentGroup,
  projectId,
  loadRoom,
  setIsReset,
  hoverItem,
  setHoverItem,
  isEq,
  access,
  isOrderFinalised,
  refreshProjectSummary,
}) => {
  const navigate = useNavigate();
  const { setIsRemarksOn, setIsExpoOn } = useContext(AppContext);
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [currentEditModalName, setCurrentEditModalName] = useState(null);
  const [roomDropdown, setRoomDropdown] = useState(false);
  const [editProject, setEditProject] = useState(false);
  const [addRoomModal, setAddRoomModal] = useState(false);
  const [editRoom, setEditRoom] = useState(false);
  const [addGroupModal, setAddGroupModal] = useState(false);
  const [editGroup, setEditGroup] = useState(false);
  const [summary, setSummary] = useState({
    price: false,
    measurement: false,
    expo: false,
    color: false,
    material: false,
    label: false,
    others: false,
  });
  const [activeReviewTab, setActiveReviewTab] = useState("design");

  const toggleRoomDropdown = () => setRoomDropdown(!roomDropdown);

  const toggleEditProject = () => setEditProject(!editProject);

  const toggleAddRoom = () => setAddRoomModal(!addRoomModal);

  const toggleEditRoom = () => {
    setEditRoom(!editRoom);
  };

  const toggleAddGroup = () => setAddGroupModal(!addGroupModal);

  const toggleEditGroup = () => setEditGroup(!editGroup);

  useEffect(() => {
    setIsRemarksOn(!!summary.remarks);
  }, [summary.remarks]);

  useEffect(() => {
    setIsExpoOn(!!summary.expo);
  }, [summary.expo]);

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const updateProject = ({ projectId, payload }) => {
    setIsLoading(true);

    return updateUserProject({ projectId, payload })
      .catch((err) => {
        if (err.cause && err.cause.code === 403) {
          navigate("/login_with_otp");
        } else {
          setIsNotificationVisible(true);
          setNotification({ type: "error", message: err.error });
        }
      })
      .finally((_) => setIsLoading(false));
  };

  const addRoom = (payload) => {
    setIsLoading(true);

    return addUserRoom({ projectId: projectId, payload })
      .then(({ room }) => {
        updateLocalProject({
          entityName: room.name,
          entityId: room.id,
          entity: "room",
          action: "add",
        });
        loadRoom(room.id);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => setIsLoading(false));
  };

  // Allowed Updates [Name]
  const updateRoom = ({ projectId, roomId, payload }) => {
    setIsLoading(true);

    return updateUserRoom({ projectId, roomId, payload })
      .then((_) => {
        updateLocalProject({
          entityName: payload.name,
          entityId: roomId,
          entity: "room",
          action: "update",
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => setIsLoading(false));
  };

  const deleteRoom = (projectId, roomId) => {
    setIsLoading(true);

    return deleteUserRoom({ projectId, roomId })
      .then((_) => {
        updateLocalProject({
          entityId: roomId,
          entity: "room",
          action: "delete",
        });
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => setIsLoading(false));
  };

  const addGroup = ({ projectId, roomId, payload }) => {
    setIsLoading(true);

    return addUserGroup({ projectId, roomId, payload })
      .then(({ group }) => {
        updateLocalProject({
          entity: "group",
          entityId: group.id,
          entityName: group.name,
          parentId: roomId,
          action: "add",
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => setIsLoading(false));
  };

  const updateGroup = ({ projectId, groupId, roomId, payload }) => {
    setIsLoading(true);

    return updateUserGroup({ projectId, groupId, payload })
      .then((_) => {
        updateLocalProject({
          entity: "group",
          entityId: groupId,
          entityName: payload.name,
          parentId: roomId,
          action: "update",
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => setIsLoading(false));
  };

  const updateLocalProject = ({
    entity = "room",
    entityId,
    entityName,
    parentId = null, // roomId for entity 'Group'
    action,
  }) => {
    if (entity === "room") {
      return updateLocalRoom({
        roomName: entityName,
        roomId: entityId,
        action,
      });
    }

    if (entity === "group") {
      return updateLocalGroup({
        groupId: entityId,
        groupName: entityName,
        roomId: parentId,
        action,
      });
    }
  };

  const updateLocalRoom = ({ roomName, roomId, action }) => {
    switch (action) {
      case "add": {
        projectSummary.rooms.push({ id: roomId, name: roomName });

        break;
      }
      case "update": {
        const roomIndex = projectSummary.rooms.findIndex(
          (room) => room.id === roomId
        );
        projectSummary.rooms[roomIndex] = {
          ...projectSummary.rooms[roomIndex],
          name: roomName,
        };

        break;
      }
      case "delete": {
        projectSummary.rooms = projectSummary.rooms.filter(
          (room) => room.id !== roomId
        );

        if (projectSummary.rooms?.length) {
          loadRoom(projectSummary.rooms[0].id);
        }

        break;
      }
    }
  };

  const updateLocalGroup = ({ roomId, groupName, groupId, action }) => {
    // Mutating "project" -> To update the group names in module "Add To Room" CTA
    switch (action) {
      case "add": {
        currentRoom.groups.push({
          id: groupId,
          name: groupName,
          modules: [],
          position: { x: 0, y: 0 },
          dimensions: { height: 0, width: 0, depth: 0 },
          type: "group",
          category: "StackedGroup",
        });

        break;
      }
      case "update": {
        const groupIndex = currentRoom.groups.findIndex(
          (group) => group.id == groupId
        );

        currentRoom.groups[groupIndex].name = groupName;
        currentRoom.groups[groupIndex] = {
          ...currentRoom.groups[groupIndex],
          name: groupName,
        };

        break;
      }
      case "delete": {
        currentRoom.groups = currentRoom.groups.filter(
          (group) => group.id !== groupId
        );

        loadRoom(currentRoom.id);

        break;
      }
    }
  };

  const getOrderItems = (items, orderItems = []) => {
    const [itemValue] = Object.values(items);
    const itemKeys = Object.keys(items);

    if (typeof itemValue === "boolean") {
      return orderItems.push(itemKeys);
    }

    for (const item in items) {
      getOrderItems(items[item], orderItems);
    }

    return orderItems.flat();
  };

  const SummaryOptions = [
    {
      text: "Price",
      icon: "fa-solid fa-indian-rupee-sign",
      key: "price",
    },
    {
      text: "Size",
      icon: "fa-solid fa-ruler",
      key: "measurement",
    },
    {
      text: "Expo",
      icon: ExpoImg,
      key: "expo",
    },
    {
      text: "Color",
      icon: "fa-solid fa-palette",
      key: "color",
    },
    {
      text: "Material",
      icon: MaterialIcon,
      key: "material",
    },
    {
      text: "Label",
      icon: "fa-solid fa-tags",
      key: "label",
    },
    {
      text: "Overrides",
      icon: "fa-solid fa-sliders",
      key: "others",
    },
    {
      text: "Remarks",
      icon: "fa-solid fa-comment",
      key: "remarks",
    },
  ];

  return (
    <div className="position-relative z-3">
      <div className="fh left-pane">
        {notification.type && (
          <Notification
            color={notification.type === "error" ? "danger" : "success"}
            isOpen={isNotificationVisible}
            toggle={onDismissNotification}
          >
            {notification.message}
          </Notification>
        )}

        {currentRoom && projectSummary && (
          <FullViewContainer
            className={`project-summary ${isLoading ? "blurred" : ""}`}
          >
            <CrudModal
              isOpen={editProject}
              toggle={toggleEditProject}
              crudAction={(projectId, _, payload) =>
                updateProject({ projectId, payload })
              }
              id={projectId}
              name={currentEditModalName}
              text="Edit project Name"
            />
            <CrudModal
              isOpen={addRoomModal}
              toggle={toggleAddRoom}
              crudAction={(projectId, _, payload) => addRoom(payload)}
              id={projectId}
              text="Add Room"
            />
            <CrudModal
              isOpen={editRoom}
              toggle={toggleEditRoom}
              crudAction={(projectId, roomId, payload) =>
                updateRoom({ projectId, roomId, payload })
              }
              id={projectId}
              roomId={currentRoom.id}
              name={currentEditModalName}
              text="Edit Room Name"
            />
            <CrudModal
              isOpen={addGroupModal}
              toggle={toggleAddGroup}
              crudAction={(projectId, roomId, payload) =>
                addGroup({ projectId, roomId, payload })
              }
              id={projectId}
              roomId={currentRoom.id}
              text="Add Group"
            />

            {editGroup && (
              <CrudModal
                isOpen={editGroup}
                toggle={toggleEditGroup}
                crudAction={(projectId, groupId, payload) =>
                  updateGroup({
                    projectId,
                    groupId,
                    roomId: currentRoom.id,
                    payload,
                  })
                }
                id={projectId}
                name={currentEditModalName}
                groupId={selectionManager.selectedGroup()?.id}
                text="Edit Group"
              />
            )}

            <div className="d-flex flex-wrap justify-content-between align-items-center px-2 py-2 pe-2">
              <Input
                className="py-1 form-select"
                name="select"
                type="select"
                value={currentRoom.id}
                style={{ width: "100px", fontSize: "1em" }}
                onChange={(e) => {
                  loadRoom(
                    Number(e.target.value),
                    null,
                    null,
                    false,
                    null,
                    true
                  );
                }}
              >
                {projectSummary.rooms &&
                  projectSummary.rooms.map((room, index) => (
                    <option key={index} value={room.id}>
                      {room.name}
                    </option>
                  ))}
              </Input>
              <div className="d-flex column-gap-2 align-items-center">
                {currentRoom.price && currentRoom.price != 0 && (
                  <p className="m-0 fw-bold">
                    ₹{currentRoom.price.toLocaleString("en-IN")}
                  </p>
                )}
                {access.add_room && (
                  <ProjectDropDown
                    isOpen={roomDropdown}
                    toggle={() => {
                      setCurrentEditModalName(currentRoom.name);
                      toggleRoomDropdown();
                    }}
                    id={projectId}
                    roomId={currentRoom.id}
                    text="Room"
                    bgcolor="white !important"
                    onDelete={deleteRoom}
                    toggleAddModal={toggleAddRoom}
                    toggleModal={toggleEditRoom}
                    isOrderFinalised={isOrderFinalised}
                    loadRoom={loadRoom}
                    projectSummary={projectSummary}
                    selectionManager={selectionManager}
                  />
                )}
              </div>
            </div>

            <div className="d-flex px-2 border-top ">
              <p
                className={`m-0 p-2 tab me-2 ${
                  activeReviewTab === "design" ? "active" : ""
                }`}
                onClick={() => setActiveReviewTab("design")}
              >
                Design
              </p>
              <p
                className={`m-0 p-2 tab ${
                  activeReviewTab === "review" ? "active" : ""
                } `}
                onClick={() => setActiveReviewTab("review")}
              >
                Review
              </p>
            </div>

            {activeReviewTab == "design" ? (
              <>
                <div className="d-flex align-items-center flex-wrap p-2 gap-1 border-top border-bottom border-secondary-emphasis">
                  {SummaryOptions.map((e, index) => {
                    return (
                      <>
                        <SummaryButton
                          id={`t_${index}`}
                          key={index}
                          onClick={() => {
                            setSummary({
                              ...summary,
                              [e.key]: !summary[e.key],
                            });
                          }}
                          className={`${summary[e.key] == true && "active"}`}
                        >
                          {["expo", "material"].includes(e.key) ? (
                            <ActionIcon className="p-0">
                              <e.icon />
                            </ActionIcon>
                          ) : (
                            <i className={`${e.icon}`} />
                          )}
                        </SummaryButton>
                        <UncontrolledTooltip
                          style={{
                            fontSize: "16px",
                            padding: "6px 20px",
                          }}
                          target={`t_${index}`}
                          placement="bottom"
                        >
                          {e.text}
                        </UncontrolledTooltip>
                      </>
                    );
                  })}
                </div>

                <ModuleListAccordion
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  currentRoom={currentRoom}
                  projectSummary={projectSummary}
                  selectionManager={selectionManager}
                  setCurrentGroup={setCurrentGroup}
                  projectId={projectId}
                  loadRoom={loadRoom}
                  setIsReset={setIsReset}
                  hoverItem={hoverItem}
                  setHoverItem={setHoverItem}
                  isEq={isEq}
                  access={access}
                  isOrderFinalised={isOrderFinalised}
                  fromOrderReview={false}
                  summary={summary}
                />
              </>
            ) : (
              <OrderReview
                reviewDetails={currentRoom.review_details}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                currentRoom={currentRoom}
                projectSummary={projectSummary}
                selectionManager={selectionManager}
                setCurrentGroup={setCurrentGroup}
                projectId={projectId}
                loadRoom={loadRoom}
                setIsReset={setIsReset}
                hoverItem={hoverItem}
                setHoverItem={setHoverItem}
                isEq={isEq}
                access={access}
                isOrderFinalised={isOrderFinalised}
              />
            )}
          </FullViewContainer>
        )}
      </div>
    </div>
  );
};

export default ProjectSummary;
